<div class="box card-box shadow">
  <div class="box-header">
    <h3>{{ 'EMPLOYEE_HIRE.additional_contract_info' | translate }}</h3>
  </div>
  <div class="box-body clearfix">
    <div *ngIf="loadingRegulations" class="padding">
      <em class="fa fa-light fa-spinner fa-spin"></em>
    </div>
    <form [formGroup]="regulationForm"
          autocomplete="off"
          novalidate
          [attr.data-hidden]="loadingRegulations">
      <!-- Regulation -->
      <div class="form-group col-md-12">
        <label for="regulation">
          {{ 'EMPLOYEE_HIRE.regulation' | translate }} <span class="required">*</span>
        </label>
        <div>
          <gp-tree-select class="form-control"
                          [tree]="regulationTree"
                          (ngModelChange)="regulationSelected($event)"
                          [placeholder]="'EMPLOYEE_HIRE.select_regulation' | translate"
                          formControlName="regulation"
                          test-id="regulation"
                          id="regulation"
                          ngDefaultControl
                          [isSorted]="true"
                          [readOnly]="loadingPaySerie || regulationReadOnly">
          </gp-tree-select>
          <ul class="error-list"
              [attr.data-hidden]="regulationForm.controls.regulation.valid || regulationForm.controls.regulation.pristine">
          </ul>
        </div>
      </div>
      <div #fieldRowsContainer></div>
    </form>
  </div>
</div>
